<template>
  <AppLink to="/">
    <AppImg src="/images/logo.svg" alt="Logo" width="160" height="45" />
  </AppLink>
</template>

<style scoped>
/* iOS */
img {
  width: min-content !important;
  min-width: fit-content;
}
@media (max-width: 850px) {
  img {
    width: 128px;
    height: 36px;
  }
}
</style>